import React, { Component } from 'react';
import { compose } from 'redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';

import { bookingFormInitialValues } from '../store/reducers';
import { setStep } from '../store/actions';
import { PAYMENT_METHOD_WITHOUT_PAYMENT } from '../constants'
import {getLabelForSelectedValue, formatPrice, getTerms, SANDAMIANO_HOTEL_ID} from '../utils';
import { guestFields, companyFields } from '../enums/Guest';
import { guestDetailFields, IDCARD_TYPE_PASSPORT } from '../enums/GuestDetails';
import PaymentGateway from "../enums/PaymentGateway";
import StayType from '../enums/StayType';
import {
	getRoomPrice,
	getBoardBaseTotalPrice,
	getBoardBasesTotalPrice,
	getBoardBasesTotalBoardBasePrice,
	getNoOfSelectedBoardBase,
	getNoOfSelectedRooms,
	getSelectedExtraFees,
	getTotalExtraFeePrice,
	isAutoExtraFeeApplicable,
	getTotalPricelistFees,
	isSelectedBoardBase,
	isSelectedExtraFee,
	isAtLeastOnePricelistFeeIncluded,
	getPackagePrice,
	getRoomNoOfGuests,
	getRoomsNoOfGuests,
	getPackageAccommodationPrice,
	isWithoutAccommodation,
} from '../apiHelpers';
import GopayInline from "./GopayInline";
import PaymentMethodInput from './PaymentMethodInput';
import CheckboxInput from './CheckboxInput';
import T from './Translate';
import withLocalize from '../withLocalize';
import {
	getDiscountCodePrice,
	getDiscountCodeResponse,
	isDiscountCodeValid
} from "../store/discountCodeSelector";
import ReservationStatus from "../enums/ReservationStatus";

// pořadí + popisky pro rekapitulaci osobních údajů hostů (sandamiano) - stejná pole jako ve formuláři
// GuestDetails/Guest.jsx, jen bez podpisu (obrázek nemá smysl zobrazovat jako text ke kontrole)
const guestDetailsRecapFields = [
	...guestDetailFields.filter(field => field.name !== 'idcard_number' && field.name !== 'signature'),
];
const idcardNumberIndex = guestDetailsRecapFields.findIndex(field => field.name === 'street');
guestDetailsRecapFields.splice(
	idcardNumberIndex,
	0,
	{ name: 'idcard_number', label: 'GuestDetails.idcardNumber' },
	{ name: 'visa', label: 'GuestDetails.visa' },
);

function getGuestDetailValue(guest, fieldName, t) {
	const value = guest[fieldName];
	if (!value) return null;

	switch (fieldName) {
		case 'sex':
			return t('GuestDetails.sex.' + value);
		case 'idcard_type_id':
			return t(parseInt(value, 10) === IDCARD_TYPE_PASSPORT ? 'GuestDetails.idcardType.passport' : 'GuestDetails.idcardType.id');
		case 'citizenship_id':
		case 'country_id':
			return t('countries.' + value);
		default:
			return value;
	}
}

class Step5 extends Component {

	componentWillMount() {
		this.props.dispatch(setStep(5));
	}

	render() {
		const {
			formValues,
			boardBases,
			dietRestrictions,
			extraFees,
			packages,
			eventPackage,
			isPaymentGatewayEnabled,
			paymentGateway,
			error,
			isOnlineReservationWithoutPaymentEnabled,
			isAdvancePaymentRequired,
			advancePaymentPercentage,
			stornoInsurance,
			stornoInsurancePrice,
			totalPrice,
			priceToPay,
			noOfNights,
			terms,
			guestTypes,
			applyGuestTypeDiscountToBoardBase,
			translate: t,
			translatePropertyValue,
			apiRoomsResponse,
			isDiscountCodeValid,
			discountCodeResponse,
			discountCodePrice,
			isVatPayer,
			hotelId,
			totalNoOfGuests,
		} = this.props;

		// rezervace pouze kalendářové události bez ubytování (bez typu pobytu, poplatků a detailů hostů)
		const withoutAccommodation = isWithoutAccommodation(formValues);

		const selectedBoardBasePrice = typeof formValues.boardBase === 'object'
			? getBoardBasesTotalPrice(boardBases, formValues.boardBase, guestTypes, noOfNights, applyGuestTypeDiscountToBoardBase, formValues.currency)
			: (formValues.boardBase ? getBoardBaseTotalPrice(boardBases[formValues.boardBase], guestTypes, formValues.rooms, noOfNights, applyGuestTypeDiscountToBoardBase, formValues.currency) : null);
		const isAdvancePaymentOptional = advancePaymentPercentage < 100;
		// s vybraným balíčkem se automaticky počítají jen příplatky/slevy, které jsou na daný balíček omezené
		// - ostatní se v rekapitulaci nezobrazují (jinak by šlo o matoucí řádek s nulovou cenou)
		const autoExtraFees = apiRoomsResponse
			? apiRoomsResponse.extraFees.filter(extraFee => isAutoExtraFeeApplicable(formValues.rooms, extraFee))
			: null;
		// Přednastavený balíček/událost má jednu pevnou cenu za celou rezervaci, v souhrnu ji proto zobrazíme jen
		// u prvního řádku, který na balíček odkazuje.
		let eventPackagePriceShown = false;
		const pricelistFees = apiRoomsResponse ? apiRoomsResponse.pricelistFees : {};

		// Deklarace ceny podle Google Referral Experience Policy.
		// Pokud se část poplatků hradí až na místě, nesmíme cenu označit za konečnou.
		const hasNotIncludedFees = isAtLeastOnePricelistFeeIncluded(pricelistFees, false);
		let priceNoteKey = null;
		if (hasNotIncludedFees) {
			priceNoteKey = isVatPayer ? 'Step4.priceNote.vatOnly' : null;
		} else {
			priceNoteKey = isVatPayer ? 'Step4.priceNote.vatAndFees' : 'Step4.priceNote.feesOnly';
		}

		return (
			<section className="container">
				<fieldset className="fieldset">
					<legend><T id="Step4.stayFields" /></legend>

					<div className="fieldset__columns">
						<div className="overview-row">
							<label className="overview-row__label"><T id="DepartureArrival.arrival" /></label>
							<span className="overview-row__value">{formValues.arrival}</span>
						</div>

						<div className="overview-row">
							<label className="overview-row__label"><T id="DepartureArrival.departure" /></label>
							<span className="overview-row__value">{formValues.departure}</span>
						</div>

						{!withoutAccommodation &&
						<React.Fragment>
							<div className="overview-row">
								<label className="overview-row__label"><T id="DepartureArrival.noOfNights" /></label>
								<span className="overview-row__value">{noOfNights}</span>
							</div>

							<div className="overview-row">
								<label className="overview-row__label"><T id="Step2.stayType" /></label>
								<span className="overview-row__value">{t(getLabelForSelectedValue(StayType.getOptions(), formValues.stayType))}</span>
							</div>
						</React.Fragment>
						}
					</div>
				</fieldset>

				<fieldset className="fieldset">
					<legend><T id="Step4.guestFields.title" /></legend>
					<div className="fieldset__columns">
						{(hotelId === SANDAMIANO_HOTEL_ID
							// sandamiano: ve Step4 se z guestFields vyplňuje jen email a telefon, ostatní pole
							// se nezobrazují a v rekapitulaci by mohly obsahovat zbytkové hodnoty z jiné rezervace
							? guestFields.filter(field => ['email', 'phone'].concat(withoutAccommodation ? ['firstName', 'lastName'] : []).includes(field.name))
							: guestFields
						).map((field, index) => (
							<div className="overview-row" key={`guestFields-${field.name}`}>
								<label className="overview-row__label">{t(field.label)}</label>
								<span className="overview-row__value" title={field.name === 'email' ? formValues[field.name] : ''}>{formValues[field.name]}</span>
							</div>
						))}
					</div>
				</fieldset>

				{hotelId === SANDAMIANO_HOTEL_ID && !withoutAccommodation && Array.isArray(formValues.guestDetails) &&
					formValues.guestDetails.slice(0, totalNoOfGuests).map((guest, index) => (
						<fieldset className="fieldset" key={`guestDetails-${index}`}>
							<legend><T id="GuestDetails.guest" data={{ count: index + 1 }} /></legend>
							<div className="fieldset__columns">
								{dietRestrictions && Object.keys(dietRestrictions).length > 0 && formValues.dietRestriction && formValues.dietRestriction[index] && dietRestrictions[formValues.dietRestriction[index]] &&
								<div className="overview-row" key={`guestDetails-${index}-dietRestriction`}>
									<label className="overview-row__label">{t('GuestDetails.dietRestriction')}</label>
									<span className="overview-row__value">{translatePropertyValue(dietRestrictions[formValues.dietRestriction[index]].name)}</span>
								</div>
								}
								{guestDetailsRecapFields.map(field => {
									const value = getGuestDetailValue(guest, field.name, t);
									if (!value) return null;
									return (
										<div className="overview-row" key={`guestDetails-${index}-${field.name}`}>
											<label className="overview-row__label">{t(field.label)}</label>
											<span className="overview-row__value">{value}</span>
										</div>
									);
								})}
							</div>
						</fieldset>
					))
				}

				{hotelId === SANDAMIANO_HOTEL_ID && withoutAccommodation && dietRestrictions && Object.keys(dietRestrictions).length > 0 && Array.isArray(formValues.dietRestriction) &&
				<fieldset className="fieldset">
					<legend><T id="GuestDetails.dietRestriction" /></legend>
					<div className="fieldset__columns">
						{Array.from({ length: totalNoOfGuests }, (_, index) => (
							dietRestrictions[formValues.dietRestriction[index]] &&
							<div className="overview-row" key={`dietRestriction-${index}`}>
								<label className="overview-row__label"><T id="GuestDetails.guest" data={{ count: index + 1 }} /></label>
								<span className="overview-row__value">{translatePropertyValue(dietRestrictions[formValues.dietRestriction[index]].name)}</span>
							</div>
						))}
					</div>
				</fieldset>
				}

				{formValues.isCompany === true &&
				<fieldset className="fieldset">
					<legend><T id="Step4.companyFields.title" /></legend>
					<div className="fieldset__columns">
						{companyFields.map((field, index) => (
							<div className="overview-row" key={`companyFields-${field.name}`}>
								<label className="overview-row__label">{t(field.label)}</label>
								<span className="overview-row__value">{field.name === 'companyCountry' ? t('countries.' + formValues[field.name]) : formValues[field.name]}</span>
							</div>
						))}
					</div>
				</fieldset>
				}

				<fieldset className="fieldset">
					<legend><T id="Step4.roomsToReserve" /></legend>
					<div className="fieldset__columns">
						{hotelId === SANDAMIANO_HOTEL_ID && eventPackage ? (() => {
							// sandamiano: všechny vybrané pokoje patří ke stejnému balíčku , takže je místo rozpisu
							// po jednotlivých pokojích zobrazíme jako jeden souhrnný řádek
							const totalGuestTypes = {};
							let totalPersons = 0;
							let totalAccommodationPrice = 0;
							Object.values(formValues.rooms).forEach(roomsOfType => {
								roomsOfType.forEach(room => {
									Object.entries(room.guestTypes || {}).forEach(([guestTypeId, count]) => {
										totalGuestTypes[guestTypeId] = (totalGuestTypes[guestTypeId] || 0) + count;
										totalPersons += count;
									});
									// samostatně nastavená cena ubytování u balíčku se počítá za každý pokoj (bez ubytování se neúčtuje)
									if (!withoutAccommodation) {
										totalAccommodationPrice += getPackageAccommodationPrice(eventPackage, noOfNights, formValues.currency, false, getRoomNoOfGuests(room));
									}
								});
							});

							return (
								<React.Fragment>
									<div className="overview-row">
										<label className="overview-row__label">{translatePropertyValue(eventPackage.name)}</label>
										<span className="overview-row__value">{
											formatPrice(getPackagePrice(eventPackage, noOfNights, formValues.currency, false, totalPersons), formValues.currency)
										}, <T id="Step4.persons" data={{ count: totalPersons }} />{ReservationStatus.getGuestTypesForRoom(guestTypes, totalGuestTypes, translatePropertyValue)}</span>
									</div>
									{totalAccommodationPrice > 0 &&
									<div className="overview-row">
										<label className="overview-row__label"><T id="Step5.accommodation" /></label>
										<span className="overview-row__value">{
											formatPrice(totalAccommodationPrice, formValues.currency)
										}, <T id="Step4.persons" data={{ count: totalPersons }} />{ReservationStatus.getGuestTypesForRoom(guestTypes, totalGuestTypes, translatePropertyValue)}</span>
									</div>
									}
								</React.Fragment>
							);
						})() : Object.entries(formValues.rooms).map(([roomTypeId, rooms], roomTypeIndex) => {
							return rooms.map((room, roomIndex) => {
								const roomPackage = room.package ? packages[room.package] : null;
								const isEventPackage = !!(roomPackage && eventPackage && roomPackage.id === eventPackage.id);

								let roomPrice;
								if (isEventPackage) {
									roomPrice = eventPackagePriceShown ? 0 : getPackagePrice(roomPackage, noOfNights, formValues.currency, false, getRoomsNoOfGuests(formValues.rooms));
									eventPackagePriceShown = true;
								} else {
									roomPrice = roomPackage
										? getPackagePrice(roomPackage, noOfNights, formValues.currency, false, getRoomNoOfGuests(room))
										: getRoomPrice(room, formValues.currency, room.guestTypes, guestTypes);
								}
								// samostatně nastavená cena ubytování u balíčku - zobrazí se jako samostatná položka (počítá se za tento pokoj bez ohledu na "counted once" pravidlo balíčku)
								const roomAccommodationPrice = roomPackage
									? getPackageAccommodationPrice(roomPackage, noOfNights, formValues.currency, false, getRoomNoOfGuests(room))
									: 0;
								return (
									<React.Fragment key={`${roomTypeId}-${roomIndex}`}>
										<div className="overview-row">
											<label className="overview-row__label">
												{translatePropertyValue(room.name)}
												{roomPackage && <span> ({translatePropertyValue(roomPackage.name)})</span>}
											</label>
											<span className="overview-row__value">{
												formatPrice(roomPrice, formValues.currency)
											}, <T id="Step4.persons" data={{
												count: typeof room.guestTypes === 'object'
													? Object.keys(room.guestTypes).reduce((accumulator, guestTypeId) =>
														accumulator + room.guestTypes[guestTypeId], 0)
													: room.guestTypes
											}} />{ReservationStatus.getGuestTypesForRoom(guestTypes, room.guestTypes, translatePropertyValue)}</span>
										</div>
										{roomAccommodationPrice > 0 &&
										<div className="overview-row">
											<label className="overview-row__label"><T id="Step5.accommodation" /></label>
											<span className="overview-row__value">{
												formatPrice(roomAccommodationPrice, formValues.currency)
											}, <T id="Step4.persons" data={{
												count: typeof room.guestTypes === 'object'
													? Object.keys(room.guestTypes).reduce((accumulator, guestTypeId) =>
														accumulator + room.guestTypes[guestTypeId], 0)
													: room.guestTypes
											}} />{ReservationStatus.getGuestTypesForRoom(guestTypes, room.guestTypes, translatePropertyValue)}</span>
										</div>
										}
									</React.Fragment>
								);
							});
						})}
						{isDiscountCodeValid && (
							<div className="overview-row">
								<label className="overview-row__label"><T id="Step5.discountCode" /> {discountCodeResponse.discountCode}</label>
								<span className="overview-row__value">
									-{formatPrice(discountCodePrice, formValues.currency)}
								</span>
							</div>
						)}
					</div>
				</fieldset>

				{(autoExtraFees.length > 0 || isSelectedExtraFee(formValues)) &&
				<fieldset className="fieldset">
					<legend><T id="Step4.extraFees" /></legend>
					<div className="fieldset__columns">
						{autoExtraFees.length > 0 && autoExtraFees.map(extraFee =>
						<div key={extraFee.id} className="overview-row">
							<label className="overview-row__label">
								{getNoOfSelectedRooms(formValues) > 1 &&
								<span>{getNoOfSelectedRooms(formValues)} &times; </span>
								}
								{translatePropertyValue(extraFee.name)}
							</label>
							<span className="overview-row__value">{getTotalExtraFeePrice(formValues.rooms, guestTypes, extraFee, true, noOfNights, formValues.currency, true, eventPackage ? getPackagePrice(eventPackage, noOfNights, formValues.currency, false, getRoomsNoOfGuests(formValues.rooms)) : null)}</span>
						</div>
						)}
						{isSelectedExtraFee(formValues) && Object.entries(getSelectedExtraFees(formValues)).map(([extraFeeId, noOfSelectedExtraFee]) =>
						<div key={extraFeeId} className="overview-row">
							<label className="overview-row__label">
								{noOfSelectedExtraFee > 1 &&
								<span>{noOfSelectedExtraFee} &times; </span>
								}
								{translatePropertyValue(extraFees[extraFeeId].name)}
							</label>
							<span className="overview-row__value">{getTotalExtraFeePrice(formValues.rooms, guestTypes, extraFees[extraFeeId], false, noOfNights, formValues.currency)}</span>
						</div>
						)}
					</div>
				</fieldset>
				}

				{(isSelectedBoardBase(formValues) || (!withoutAccommodation && isAtLeastOnePricelistFeeIncluded(pricelistFees))) &&
				<fieldset className="fieldset">
					<legend><T id="Step4.servicesAndOtherFees" /></legend>
					<div className="fieldset__columns">
						{isSelectedBoardBase(formValues) && typeof formValues.boardBase !== 'object' &&
						<div className="overview-row">
							<label className="overview-row__label">
								{getNoOfSelectedBoardBase(formValues, guestTypes) > 1 &&
								<span>{getNoOfSelectedBoardBase(formValues, guestTypes)} &times; </span>
								}
								{t('BoardBase.' + boardBases[formValues.boardBase].id)}
							</label>
							<span className="overview-row__value">{selectedBoardBasePrice}</span>
						</div>
						}
						{isSelectedBoardBase(formValues) && typeof formValues.boardBase === 'object' && Object.keys(formValues.boardBase).map((boardBase, index) => getNoOfSelectedBoardBase(formValues, guestTypes, boardBase) < 1 ? '' :
						<div className="overview-row">
							<label className="overview-row__label">
								<span>{getNoOfSelectedBoardBase(formValues, guestTypes, boardBase)} &times; </span>
								{t('BoardBase.' + boardBases[boardBase].id)}
							</label>
							<span className="overview-row__value">{getBoardBasesTotalBoardBasePrice(boardBases[boardBase], formValues.boardBase, guestTypes, noOfNights, applyGuestTypeDiscountToBoardBase, formValues.currency)}</span>
						</div>
						)}
						{!withoutAccommodation && isAtLeastOnePricelistFeeIncluded(pricelistFees) &&
						<div className="overview-row">
							<label className="overview-row__label">
								<T id="Rooms.RoomOffer.fees"/>
							</label>
							<span className="overview-row__value">
								{formatPrice(
									getTotalPricelistFees(pricelistFees, formValues.rooms, noOfNights, formValues.currency, formValues.stayType),
									formValues.currency
								)}
							</span>
						</div>
						}
						{formValues.stornoInsurance && !withoutAccommodation &&
						<div className="overview-row">
							<label className="overview-row__label">
								<T id="Step4.servicesAndOtherFees.stornoInsurance"/>
							</label>
							<span className="overview-row__value">
								{formatPrice(stornoInsurancePrice, formValues.currency)}
							</span>
						</div>
						}
					</div>
				</fieldset>
				}

				{isPaymentGatewayEnabled && paymentGateway &&
				<fieldset className="fieldset">
					<legend><T id="Step4.paymentType" /></legend>
					{isAdvancePaymentRequired &&
						<div className="alert-container"><T id="Step4.paymentType.advancePaymentAlert" data={{ advancePaymentPercentage }}/></div>
					}
					{!isAdvancePaymentRequired && isAdvancePaymentOptional && formValues.paymentMethod !== PAYMENT_METHOD_WITHOUT_PAYMENT &&
						<Field
							component={CheckboxInput}
							name="advancePaymentOnly"
							label={t('Step4.paymentType.advancePaymentOnly', { advancePaymentPercentage })}
							id="advancePaymentOnly"
						/>
					}
					{error && <div className="large-input-container__error large-input-container__error--radio">{error}</div>}
					<div className="payment-methods">
						{paymentGateway.instruments[formValues.currency.id].map((instrument, index) => (
							<Field
								component={PaymentMethodInput}
								name="paymentMethod"
								key={instrument.paymentInstrument}
								instrument={instrument}
								checked={formValues.paymentMethod === instrument.paymentInstrument}
							/>
						))}
						{isOnlineReservationWithoutPaymentEnabled &&
							<Field
								component={PaymentMethodInput}
								name="paymentMethod"
								instrument={{
									paymentInstrument: PAYMENT_METHOD_WITHOUT_PAYMENT,
									label: {
										cs: t('Step4.paymentType.paymentMethodWithoutPayment'),
									}
								}}
								checked={formValues.paymentMethod === PAYMENT_METHOD_WITHOUT_PAYMENT}
							/>
						}
					</div>
					{paymentGateway.slug === PaymentGateway.GOPAY && paymentGateway.scriptUrl !== null && <GopayInline src={paymentGateway.scriptUrl} />}
				</fieldset>
				}

				{isAtLeastOnePricelistFeeIncluded(pricelistFees, false) &&
				<fieldset className="fieldset fieldset--red-highlight">
					<T id="Step4.pricelistFeesNotIncluded"
					   data={{ fees: formatPrice(
							getTotalPricelistFees(
								pricelistFees, formValues.rooms, noOfNights, formValues.currency, formValues.stayType, false
							),
							formValues.currency)
					   }}
					/>
				</fieldset>
				}

				<fieldset className="fieldset fieldset--highlight">
					<div className="overview-row">
						<label className="overview-row__label overview-row__label--large"><T id="Step4.totalPrice" /></label>
						<span className="overview-row__value overview-row__value--large">{formatPrice(totalPrice, formValues.currency)}</span>
					</div>
					{formValues.advancePaymentOnly &&
					<div className="overview-row">
						<label className="overview-row__label overview-row__label--large"><T id="Step4.priceToPayNow" /></label>
						<span className="overview-row__value overview-row__value--large">{formatPrice(priceToPay, formValues.currency)}</span>
					</div>
					}
					{priceNoteKey &&
					<div className="overview-row overview-row--note">
						<T id={priceNoteKey} />
					</div>
					}
					<div className="fieldset__agree">
						<T id="Step4.agree" data={{ terms }} html={true} />
						{stornoInsurance && !withoutAccommodation &&
						<div className="fieldset__agree-storno-insurance">
							<Field
								component={CheckboxInput}
								name="stornoInsurance"
								id="stornoInsurance"
								label={t('Step4.stornoInsurance', { terms: stornoInsurance.vopUrl, price: formatPrice(stornoInsurancePrice, formValues.currency) }, true)}
							/>
						</div>
						}
					</div>
				</fieldset>

			</section>
		);
	}
}

export default compose(
	reduxForm({
		form: 'bookingForm',
		initialValues: bookingFormInitialValues,
		destroyOnUnmount: false,
	}),
	connect((state) => ({
		formValues: getFormValues('bookingForm')(state),
		hotelId: state.app.hotelId,
		roomOffers: state.app.roomOffers,
		boardBases: state.app.boardBases,
		boardBaseOptions: state.app.boardBaseOptions,
		dietRestrictions: state.app.dietRestrictions || {},
		extraFees: state.app.extraFees,
		packages: state.app.packages || {},
		eventPackage: state.app.package,
		isPaymentGatewayEnabled: state.app.isPaymentGatewayEnabled,
		isOnlineReservationWithoutPaymentEnabled: state.app.isOnlineReservationWithoutPaymentEnabled,
		paymentGateway: state.app.paymentGateway,
		isAdvancePaymentRequired: state.app.isAdvancePaymentRequired,
		advancePaymentPercentage: state.app.advancePaymentPercentage,
		stornoInsurance: state.app.stornoInsurance,
		stornoInsurancePrice: state.app.stornoInsurancePrice,
		totalPrice: state.app.totalPrice,
		priceToPay: state.app.priceToPay,
		totalNoOfGuests: state.app.totalNoOfGuests,
		noOfNights: state.app.noOfNights,
		terms: getTerms(state.app),
		guestTypes: state.app.guestTypes,
		applyGuestTypeDiscountToBoardBase: state.app.applyGuestTypeDiscountToBoardBase,
		apiRoomsResponse: state.app.apiRoomsResponse,
		isDiscountCodeValid: isDiscountCodeValid(state),
		discountCodeResponse: getDiscountCodeResponse(state),
		discountCodePrice: getDiscountCodePrice(state),
		isVatPayer: state.app.hotel && state.app.hotel.isVatPayer,
	})),
	withLocalize,
)(Step5);



// WEBPACK FOOTER //
// ./src/components/Step5.jsx